import { IDealSummary } from 'hooks/useDealSummary/interface';
export interface CustomerPrimaryContactProxy {
  userId: number;
  title?: string | null;
}
// Customers (Landing page) should send messages as the Primary Contact who is representing the customer
export const customerAsPrimaryContact = ({
  deal,
  userId
}: {
  deal?: IDealSummary | null;
  userId?: number | null;
}): CustomerPrimaryContactProxy | null => {
  const isCustomer = !!deal?.customers?.assigned?.find((b) => b.Id === userId);

  if (isCustomer && deal?.primaryContact?.Id)
    return {
      title: deal.primaryContact.Title,
      userId: Number(deal.primaryContact.Id)
    };
  else return null;
};
